<template>
    <div class=" o_list">
      <!-- <div
        class="sear"
        v-show="true"
      >
        <van-search
          v-model="value"
          placeholder="请输入商品名称"
          @search="search"
        />
      </div> -->
  
      <van-nav-bar
        class="bar"
        :title="title"
        left-text="返回"
        left-arrow
        @click-left="onClickLeft"
        :fixed="true"
      />
     
          <div class="list">
            <van-list
              v-model="loading"
              :finished="finished"
              finished-text="没有更多了"
              offset="500"
              @load="onLoad"
            >
              <van-cell
                v-for="item in list"
                :key="item.order_id"
              >
                <div class="shop">
                  <div class="head">
                    <div class="name fll">
                      <p>{{item.store_name}}</p>
                       
                    </div>
                <div class="name fl2">
                      <!-- <p> {{item.order_id}} </p> -->
  
                </div>
                <div v-if="item.refunded_type" class="state fl3">
                      {{item.refunded_type==1?'已退款':'已退部分'}}
                    
                    </div>
                    <div v-else class="state fl3">
                      {{item.down_payment_status==0?'未付定金':'已付定金'}}
                      <div
                      class="time"
                      v-show="item.down_payment_status==0"
                    >
                    </div>
                    </div>
                     
                  </div>
                  <div
                    class="body"
                    @click="go(item)"
                  >
                    <ul>
                      <li
                        class="clearfix"
                        v-for="(v,i) in item.goods"
                        v-show="i<2"
                        :key="i"
                      >
                        <img
                          :src="v.sku_thumb"
                          alt=""
                        >
                        <div class="conten">
                          <p class="title">{{v.name}}</p>
                          <div class="price">定金：￥{{(item.dingjin_money/v.goods_num).toFixed(2)}}</div>
                          <div class="num">x{{v.goods_num}}</div>
                        </div>
                      </li>
                    </ul>
                    
                  </div>
                  <div class="foot">
                    <div class="bei">备注：<span>{{item.remark}}</span></div>
                    <div class="statistics clearfix">
                      <div class="money fr">总付定金：<span>￥{{item.dingjin_money}}</span></div>
                      <!-- <div class="number fr">共计{{item.goods.length}}件商品</div> -->
                    </div>
                    <div class="but">
                      <div class="sheng fl" style="position: relative; bottom: 0.3rem;text-align: left;">
                        离定金支付结束还剩：
                        <van-count-down :time="item.time" format="DD 天 HH 时 mm 分 ss 秒" />
                      </div>
                                             <button
                        v-if="item.down_payment_status==0"
                        class="red"
                        @click="goo(item.order_id,item.dingjin_money,item.payment_end_date)"
                      >去付定金</button>
                      <div v-show="item.down_payment_status==1 && item.refunded_type==0" class="">
                      <button
                       v-show="uid==7360 ||  uid==8168"
                        :class="['red']"
                        @click="tui(item.order_id)"
                      >退定金</button>
                    </div>
                      <button
                        v-show="item.order_status=='未付款'||item.order_status=='待审核'"
                       :class="['orange']"
                        @click="ash(item,0)"
                      >取消订单</button>
                       
  
                      <button
                        v-show=" item.order_status=='已取消'"
                        :class="['orange']"
                        @click="aging(item,2)"
                      >加入购物车</button>
                      <!-- <button
                        v-show="item.order_status=='已完成'"
                        :class="['orange']"
                        @click="godetails(item,3)"
                      >发货明细</button>
                      <button
                        v-show="item.order_status=='已完成'"
                        :class="['orange']"
                        @click="godetails(item,3)"
                      >结算明细</button> -->
                      <button
                        v-show="item.order_status=='已完成'"
                        :class="['orange']"
                        @click="gof(item.id)"
                      >查看返利</button>
                      <!-- <button
                        v-show="item.order_status=='已完成'"
                        :class="['orange']"
                        @click="godetails(item,3)"
                      >查看积分</button> -->
                      <button
                        v-show="item.order_status=='已完成'"
                        :class="['orange']"
                        @click="got"
                      >申请退货</button>
                      <button
                        v-show=" item.order_status=='已取消'"
                        :class="[states?'red':'orange']"
                        @click="delet(item)"
                      >删除订单</button>
                      
                      <!-- <button
                        v-show=" item.order_status=='已取消'"
                        :class="[states?'red':'orange']"
                        @click="aging(item)"
                      >再次购买</button> -->
                     
                    </div>
                  </div>
                </div>
              </van-cell>
            </van-list>
  
          </div>
       

  
    </div>
  
  </template>
  <script>
  import Vue from 'vue'
  // import List from './child/list'
  import { NavBar, Tab, Tabs, List, Cell, Search, Dialog, Toast, CountDown } from 'vant'
  
  Vue.use(NavBar).use(Tabs).use(Tab).use(Cell).use(List).use(Search).use(Dialog).use(CountDown)
  export default {
    created () {
      this.active = this.$route.query.i - 1
      this.uid=JSON.parse(localStorage.getItem('user')).id
    },
    mounted () {
      this.deng()
      window.addEventListener('scroll', this.windowScroll)
    },
    beforeDestroy () {
      window.removeEventListener('scroll', this.windowScroll)
  
  
    },
  
    data () {
      return {
        value: '',
        title: '促销预售列表',
        nav: ['全部订单', '已提交', '已完成', '已取消'],
        active: 1,
        states: true,
        list: [],
        loading: false,
        finished: false,
        page: 1,
        showp:false,
        fml: [],
        uid:''
      }
    },
    methods: {
    async  aging (i) {
         
     await i.goods.forEach(v=>{
      if(v.ishuodong==1){
  Toast('活动商品请到活动页面购买')
      }else{
  this.axios
          .post('addcart',v)
          .then((res) => {
            if(res.data.code==200){
            Toast(res.data.msg)
        this.$router.push('car')
  
            }else{
              Toast('商品缺失，加入失败')
              return
            }
          })
          .catch((ref) => { }) 
      }
           
     })           
         
        // this.$router.push('car')
      },
      got(){
        Toast('请联系业务人员退货')
      },
      deng () {  
        // console.log(this.active)
        this.axios.post('order_list', {type:1, order_type:2,page:this.page}).then(res => {
         
          console.log(res)
          if (res.data.code == 200) {
            
            res.data.data.forEach(v => {
            v.time = Date.parse(v.payment_end_date) - (Date.parse(new Date()))
            // v.time = 0
            this.list.push(v) 
          })
         
          } else {
          this.page = 0
            
          }
          
          this.loading = false;
          this.finished = true;
        }).catch(ref => { })
      },
      onClickLeft () {
        this.$router.push('my')
      },
      cui(id,zt,it){
        
  this.axios.post('dengpaoChange', {  order_id: id }).then(res => {
            // console.log(res)
            if(res.data.code==200){
            Toast('已提醒客服加急处理，请耐心等待')
            it.dengpao=2
            }
          }).catch(ref => { })
       
  
      },
      search () {
        if (this.value == "") {
          return
        }
        console.log(this.value)
        this.list=[]
        this.deng()
        // this.axios.post('order_list', { type: 1, page: 1,serch_param:this.value }).then(res => { 
        //   console.log(res)
        // }).catch(ref => { })
      },
      goc(){
        this.$router.push('car')
      },
      gof(id){
        this.axios.post('fanliGoodsDetail', {  order_id: id }).then(res => {
            // console.log(res)
            if(res.data.code==200){
              this.fml=res.data.data
            this.showp=true
  
            }else{
              Toast('本单没有返利')
            }
          }).catch(ref => { })
      },
      change (name) {
        this.list = []
        this.page = 1
        this.onLoad(name)
      },
      onLoad (v) {
        // 异步更新数据
       
        // this.deng()
  
        
      },
      getScrollTop () {
        var scrollTop = 0
        if (document.documentElement && document.documentElement.scrollTop) {
          scrollTop = document.documentElement.scrollTop
        } else if (document.body) {
          scrollTop = document.body.scrollTop
        }
        return scrollTop
      },
      // 获取当前可视范围的高度
      getClientHeight () {
        var clientHeight = 0
        if (document.body.clientHeight && document.documentElement.clientHeight) {
          clientHeight = Math.min(document.body.clientHeight, document.documentElement.clientHeight)
        } else {
          clientHeight = Math.max(document.body.clientHeight, document.documentElement.clientHeight)
        }
        return clientHeight
      },
  
      // 获取文档完整的高度
      getScrollHeight () {
        return Math.max(document.body.scrollHeight, document.documentElement.scrollHeight)
      },
      windowScroll () {
        if (this.page == 0) {
          return false
        }
        if (this.getScrollHeight() - this.getClientHeight() - this.getScrollTop() <= 100) {
          // if (this.status === 1) {
          //   this.status = 0
          //   // 页码，分页用，默认第一页
          //   // this.deliverParams.page += 1
          //   // 调用请求函数
          //   alert('触发！！！')
          // }
          this.page++
          this.deng()
        }
      },
      go (v) {
        // if (v.order_status == '未付款') {
        //   this.$router.push({ name: 'details', params: { id: v, i: 1 } })
        // } else if (v.order_status == '已取消') {
        //   this.$router.push({ name: 'details', params: { id: v, i: 2 } })
        // }
        // else if (v.order_status == '已超时') {
        //   this.$router.push({ name: 'details', params: { id: v, i: 4 } })
        // } else {
        //   this.$router.push({ name: 'details', params: { id: v, i: 3 } })
        // }
      },
      godetails (v, i) {
        this.$router.push({ name: 'details', params: { id: v, i } })
      },
      ash (v,i) {
        Dialog.confirm({
          title:i?'使用过优惠券才能退':'是否确认取消订单',
          message: '',
  
        }).then(() => {
          this.axios.post('cancel_order', { id: v.id }).then(res => {
            if (res.data.code == 1004) {
              localStorage.setItem('token', JSON.stringify({ id: res.data.token }))
              this.ash(v)
            }
            // console.log(res)
            Toast(res.data.msg)
            this.list = []
            this.page = 1
            this.deng()
            done()
  
          }).catch(ref => { })
        }).catch(() => {
        })
      },
      tui (id) {
  
        Dialog.confirm({
          title: '优惠很大哦，真的要退款吗',
          message: '',
        }).then(() => {
          this.axios.post('returnmoney',  { return_no:id  }).then(res => {
            console.log(res)
           
              Toast(res.data.msg)
            this.deng()
            
          }).catch(ref => { })
        }).catch(() => { })
      },
      goo (id, money, t) {
       
        if (Date.parse(t) - (Date.parse(new Date())) < 0) {
          Toast('时间已经过了')
        } else {
        this.$router.push({ name: 'chuxs', query: { order: id,money } })
          
        }
      }
    },
    components: {
      // List
    }
  }
  </script>
  <style lang="less" scoped>
  .fmli{
    padding: 0.2rem;
    .ti{
      line-height: 1rem;
      text-align: center;
      font-size: 0.4rem;
    }
    li{
      height: 1rem;
      span{
        color: #f50a0a;
        float: right;
      }
    }
  }
  .sear {
    height: 1rem;
    
    width: 100%;
    .van-search {
      height: 1rem;
    }
  }
  .o_list {
    padding-top: 1.2rem;
    .bar {
      z-index: 99;
    }
  }
  .cs {
    text-align: center;
    color: red;
  }
  .tab {
    padding: 0.3rem 0;
    background-color: #f7f7f7;
  }
  .list {
    background-color: #f7f7f7;
  }
  .van-cell {
    margin: 0.3rem 0;
  }
  .shop {
    background-color: #fff;
    // padding: 0 0.3rem;
    .head {
      display: flex;
      // height: 1rem;
      // line-height: 1rem;
      // justify-content: space-between;
      .name {
        p{
        font-size: 0.4rem;
        // height: 1rem;
          // line-height: 0.5rem;
        }
      }
      .fll{
        flex: 0.4;
      }
      .fl3{
        flex:0.5
      }
      .fl2{
        flex:0.3
  
      }
      .time {
        // padding-top: 0.15rem;
        color: #a22d2b;
      }
      .state {
        text-align: right;
        // height: 1rem;
        font-size: 0.4rem;
        color: #a22d2b;
      }
    }
    .body {
      background-color: #fff;
      border-top: 1px solid #efefef;
      .dianj {
        text-align: center;
      }
      li {
        border-bottom: 1px solid #efefef;
        padding: 0.3rem 0;
        position: relative;
  
        img {
          width: 2.4rem;
          height: 2.4rem;
          float: left;
        }
        .conten {
          padding-left: 2.8rem;
          // position: absolute;
          .title {
            width: 80%;
            color: #333;
            line-height: 0.36rem;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
          }
          .type {
            width: 90%;
            color: #888;
            padding-top: 0.2rem;
          }
          .price {
            padding-top: 0.5rem;
            font-weight: 700;
            font-size: 0.45rem;
          }
          .num {
            position: absolute;
            right: 20%;
            color: #888;
            top:52%;
          }
        }
      }
    }
    .foot {
      .bei {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      background-color: #fff;
      .statistics {
        padding: 0.2rem;
        padding-top: 0;
        .money {
          padding-left: 0.3rem;
          font-size: 0.4rem;
          color: #333;
          span {
            font-size: 0.453333rem;
          }
        }
        .number {
          font-size: 0.4rem;
          color: #333;
        }
      }
      .but {
        text-align: right;
        padding: 0.2rem 0 0.5rem 0;
        button {
          width: 2rem;
          height: 0.8rem;
          background: #fff;
  
          border-radius: 5px;
          outline: none;
          margin-left: 0.2rem;
        }
        .ash {
          border: 1px solid #b0b0b0;
          color: #b0b0b0;
        }
        .red {
          border: 1px solid #a22d2b;
          color: #a22d2b;
        }
        .orange {
          border: 1px solid #f97817;
          color: #f97817;
        }
      }
    }
  }
  </style>
  